import { IconCopy, IconSend } from '@components/icons';
import { TFunction } from 'i18next';

import { OPTION_SEND_LINK } from '../src/process-invite-guest.type';

export const SendButtonText = ({
  watchedSelectedOption,
  email,
  t,
}: {
  watchedSelectedOption: string;
  email?: string;
  t: TFunction;
}) => {
  const showSendLinkButton = watchedSelectedOption === OPTION_SEND_LINK && !email;
  const showCopyLinkButton = watchedSelectedOption === OPTION_SEND_LINK && email;
  if (showCopyLinkButton)
    return (
      <>
        <IconCopy className='w-4 h-4' /> {t('invitations:copyLink')}
      </>
    );
  if (showSendLinkButton)
    return (
      <>
        <IconSend className='w-4 h-4' /> {t('invitations:sendLink')}
      </>
    );

  return (
    <>
      <IconSend className='w-4 h-4' /> {t('invitations:sendInvite')}
    </>
  );
};
